import React from 'react';

const OPEN_RYNN_EVENT = 'sovrynn-open-rynn';

export default function AnalyticsRynnPrompt() {
  const openRynn = () => {
    window.dispatchEvent(new CustomEvent(OPEN_RYNN_EVENT));
  };

  return (
    <section className="analytics-rynn-prompt" aria-label="Ask Rynn">
      <h3 className="analytics-rynn-prompt__title">Questions about your scores?</h3>
      <p className="analytics-rynn-prompt__body">
        Ask Rynn to explain what&apos;s affecting your DRI Score™ or what to prioritize next.
      </p>
      <button type="button" className="analytics-rynn-prompt__btn" onClick={openRynn}>
        Ask Rynn
      </button>
    </section>
  );
}
